window.initAssessorProfileForm = function() {
  initDatepicker();
  initMultipleSelect();
  scrollToError();

  $("[data-selecting='country']").on('change', function(){
    $.get('/form-options/cities', { country: $(this).val() });
  })

  $("[data-selecting='city']").on('change', function(){
    $.get('/form-options/areas', { country: $("[data-selecting='country']").val(), city: $(this).val() });
  })

  $('[name="assessor[travel_for_assessments]"]').on('change', function(){
    if($(this).val() == "true"){
      $('[name="assessor[travel_for_assessments_to][]"]').prop('disabled', false);
      $('[name="assessor[travel_for_assessments_to][]"]').focus();
    } else {
      $('[name="assessor[travel_for_assessments_to][]"]').prop('disabled', true);
    }
  })

  $('[name="assessor[other_mystery_company]"]').on('change', function(){
    if($(this).val() == "true"){
      $('[name="assessor[other_mystery_companies]"]').prop('disabled', false);
      $('[name="assessor[other_mystery_companies]"]').focus();
    } else {
      $('[name="assessor[other_mystery_companies]"]').prop('disabled', true);
    }
  })

  $('[name="assessor[residence_country]"]').on('change', function(){
    if($(this).val() == "AE"){
      $('.js-travel-options').removeClass('is-hidden');
      $('.js-travel-options').find('input, select').prop('disabled', false)
      initMultipleSelect();
    } else {
      $('.js-travel-options').addClass('is-hidden');
      $('.js-travel-options').find('input, select').prop('disabled', true)
    }
  })

}